<template>
  <v-row>
    <v-col cols="12" md="4" sm="6" v-if="show_machine && enableUserDropDown">
      <UserDropdown @user-selected="handleUserSelected" />
      <machineSelect
        v-if="propValueAssigned"
        @triggermachine="triggermachine($event)"
        :routed_machineID="routed_machineID"
      />
      <!-- machine select component is a separte component sending -->
    </v-col>
    <v-col v-else-if="enableUserDropDown">
      <UserDropdown @user-selected="handleUserSelected" />
    </v-col>
    <v-col v-else-if="show_machine">
      <machineSelect
        v-if="propValueAssigned"
        @triggermachine="triggermachine($event)"
        :routed_machineID="routed_machineID"
      />
    </v-col>
    <v-col>
      <div style="display: flex;">
        <v-icon medium dense color="#004080">
          icon-calender
        </v-icon>

        <v-btn
          id="button1"
          @click="DialogPopUp"
          rounded
          depressed
          style="display: flex; flex-wrap: wrap;color: #004080;font-weight: 600"
        >
          <span v-html="durationSelected"></span>
        </v-btn>
      </div>
      <div v-if="isCardVisible" class="card-div">
        <v-card
          class="v-card1"
          v-if="card"
          max-width="390px"
          width="90%"
          elevation="15"
          style="display: flex; flex-direction: column; justify-content: space-between; margin-right:10px; "
        >
          <div>
            <v-card-title class="background-blue "
              ><span style="color: white;">Duration</span></v-card-title
            >
            <v-card-text>
              <template>
                <template>
                  <v-container class="pt-0">
                    <input
                      v-model="Last"
                      type="radio"
                      checked
                      id="btn1 "
                      @click="RadioInput"
                      :value="Last"
                      name="choose1"
                      style="height:55px;margin-right:5px;width:15px;vertical-align: middle;color: #004080 "
                    />
                    <label for="btn1"> <b>Last</b></label>
                    <br />
                    <div v-show="hideLastSelectField">
                      <template>
                        <v-container fluid style="margin-top:-15px">
                          <v-row style="align:center">
                            <v-col cols="12" sm="12">
                              <v-select
                                :items="dateFilterItems"
                                label="Last"
                                v-model="selectingPredefinedDuration"
                                item-text="val"
                                item-value="id"
                                @change="OnLastSelected"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                    </div>
                    <input
                      v-model="time_period"
                      @click="TimePeriodRadioSelect"
                      type="radio"
                      :value="timeperiod"
                      id="btn2"
                      name="choose1"
                      style="height:18px;margin-right:5px; width:15px;vertical-align: middle;"
                    />
                    <label for="btn2"> <b>Time Period</b> </label>
                    <v-container fluid style="margin-top:-25px ">
                      <br />
                      <div v-show="hideDateTimeFrom">
                        <template>
                          <v-row>
                            <v-col cols="6">
                              <v-menu
                                v-model="HideFromCalender"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="date"
                                    label="From Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="date"
                                  color="primary"
                                  @input="HideFromCalender = false"
                                  style="max-width: 250px;"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="6" sm="6">
                              <v-menu
                                ref="menu"
                                v-model="menu4"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="time"
                                    label="From Time"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="menu4"
                                  v-model="time"
                                  color="primary"
                                  @click:minute="$refs.menu.save(time)"
                                  style="max-width:250px"
                                >
                                </v-time-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </template>
                      </div>
                    </v-container>

                    <v-container style="margin-top:-30px" fluid>
                      <div v-show="hideToDateTime">
                        <template>
                          <v-row>
                            <v-col cols="6">
                              <v-menu
                                v-model="HideToCalender"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="date_2"
                                    label="To Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="date_2"
                                  color="primary"
                                  @input="HideToCalender = false"
                                  style="width: 250px;"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="6" sm="6">
                              <v-menu
                                ref="timemenu"
                                v-model="HideTimeToMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="selectedTimeTo"
                                    label="To Time"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="HideTimeToMenu"
                                  v-model="selectedTimeTo"
                                  color="primary"
                                  @click:minute="$refs.timemenu.save(time)"
                                  style="max-width: 250px;"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </template>
                      </div>
                    </v-container>
                  </v-container>
                </template>
              </template>
              <br />
              <v-container style="margin-top:-50px; margin-left:-15px ">
                <div class="checkbox" v-show="check">
                  <v-checkbox
                    v-model="checkbox"
                    :label="`Real Time`"
                  ></v-checkbox>
                </div>
              </v-container>
              <v-container style="margin-top:-25px">
                <data_function
                  v-on:data_function="AssignAggregation"
                  v-show="aggfunc"
                />
              </v-container>
              <v-container style="margin-top:-40px">
                <grouping_interval
                  v-on:grouping_interval="AssignInterval"
                  v-show="show"
                />
              </v-container>
            </v-card-text>
          </div>
          <div
            class="card-btns"
            style=" display: flex; justify-content: flex-end"
          >
            <v-btn
              @click="onCancel"
              rounded
              small
              color="#FE000C"
              style="margin-left:-35px; margin-top: -25px; "
            >
              <v-icon left color="white">icon-cancel </v-icon>
              <span style="color: white; font-weight: 800;">
                Cancel
              </span>
            </v-btn>
            <v-btn
              class="update background-blue"
              @click="updateAndSubmit()"
              :disabled="incompleteFields()"
              rounded
              small
              style="margin-left:10px; margin-top: -25px;color: white"
            >
              <v-icon left>icon-availability</v-icon>Update</v-btn
            >
          </div>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import machineSelect from "./MachineDropDown.vue";
import axios from "axios";
import router from "../router";
import data_function from "./data_function.vue";
import grouping_interval from "./grouping_interval.vue";
import UserDropdown from "./UserDropdown.vue";
let todaysDate = new Date();
let dateString = `${todaysDate.getFullYear()}-${todaysDate.getMonth() +
  1}-${todaysDate.getDate()}`;

export default {
  name: "newcompoent",
  props: ["filter_data"],
  components: {
    machineSelect,
    data_function,
    grouping_interval,
    UserDropdown,
  },

  data: () => ({
    userSelected: null,
    enableUserDropDown: false,
    propValueAssigned: false,
    DropDownLabel: "Select Machine",
    timeperiod: false,
    Last: false,
    checkbox: false,
    dialog: false,
    dialog_2: false,
    show_card: false,
    date: null,
    date_2: null,
    durationSelected: "Duration",
    menu: false,
    timemenu: false,
    modal: false,
    HideFromCalender: false,
    HideToCalender: false,
    HideTimeToMenu: false,
    time: "00:00",
    selectedTimeTo: "23:59",
    menu4: false,
    modal2: false,
    radiosGroup: null,
    selectingPredefinedDuration: null,
    lengthOfMachine: null,
    my_var: null,
    hideLastSelectField: true,
    hideDateTimeFrom: false,
    hideToDateTime: false,
    show: "",
    grp_show: null,
    startTime: null,
    endTime: null,
    card: true,
    aggfunc: true,
    check: true,
    show_machine: true,
    dates: [dateString, dateString],
    dateFilterSelected: "",
    dateFilterItems: [
      { id: 1, val: "1 Hour" },
      { id: 2, val: "2 Hour" },
      { id: 5, val: "5 Hour" },
      { id: 10, val: "10 Hour" },
      { id: 24, val: "1-Day" },
      { id: 120, val: "5-Days" },
      { id: 168, val: "7-Days" },
      { id: 360, val: "15-Days" },
    ],

    time_period: false,
    machineSelected: "",
    machineItems: [],
    date_filter_id: "",
    date_filter_id_Selected: "",
    dateRangeSelected: "",
    start_date: "",
    end_date: "",
    // routed_machine_selection:null,
    routed_machineID: null,
  }),
  beforeDestroy() {
    // console.log("checking sumit")
  },

  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate page in filter", to, "--from ", from, next);
  },
  beforeMount() {
    if (this.$config.user_selectable_routes.includes(this.$route.name)) {
      this.enableUserDropDown = true;
    } else {
      this.enableUserDropDown = false;
    }
  },
  mounted() {
    this.updateDurationSelected();
    console.log("url is --", this.$route.name);
    console.log("chekcing main ", this.filter_data);

    //----------------- The following instance variables help to enable / disable  DIV on DOM --------------------------

    this.check = this.filter_data.check || false; // this helps to display real time checkbox
    this.aggfunc = this.filter_data.aggfunc || false; // this will display the field of aggregationfunction eg., min, max, avg.. etc
    //----------------------end------------------------------
    this.selectingPredefinedDuration = this.filter_data.select_1 || false;
    if (this.selectingPredefinedDuration == false) {
      this.DropDownLabel =
        this.filter_data.machineDropDownLabel || "Select Machine:";
      this.show_machine = this.filter_data.machine; // boolean to hide/ unhide machine dropdown on render
      console.log(
        "checking we have no select",
        this.selectingPredefinedDuration,
        this.filter_data
      );
      this.time_period = this.filter_data.time_period || false; // boolean to hide/ unhide time period on render
      this.TimePeriodRadioSelect(); // this will help to display div of 'Time Period' with values assigned to its fields
      this.date = this.filter_data.date || "";
      this.timeperiod = true;
      this.date_2 = this.filter_data.date_2 || "";
      console.log("checking 'Date From' & 'Date To' ", this.date, this.date_2);
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      const s = Math.floor(d.getTime() / 1000);
      let date = new Date(s * 1000);
      let hours = date.getHours();
      let minutes = "0" + date.getMinutes();
      let formattedTime = hours + ":" + minutes.substr(-2);
      this.time = formattedTime;
      console.log("checking this.time", this.time);
      let ss = Date.now();
      let date_2 = new Date(ss);
      let hours_2 = date_2.getHours();
      let minutes_2 = "0" + date_2.getMinutes();
      let formattedTime_2 = hours_2 + ":" + minutes_2.substr(-2);
      this.selectedTimeTo = formattedTime_2;
    }
    console.log(
      "checking this.selectingPredefinedDuration",
      this.$route.params
    );
    this.machineSelected = this.$route.params.macId;
    // this.routed_machine_selection = this.$route.params.macId;
    this.routed_machineID = this.$route.params.macId;
    this.propValueAssigned = true;
    console.log(
      "routed_machineID in newfilter",
      this.routed_machineID,
      this.machineSelected
    );
    this.setMachineData(this.machineSelected);

    if (this.$route.params != null && this.$route.params.macId != null) {
      this.machineSelected = this.$route.params.macId;
      console.log("assigning mac test ", this.machineSelected);
    }

    // clearing the session data in overallAUditData
    // if (
    //   sessionStorage.getItem("selectedMachine") &&
    //   !this.$route.params.macId
    // ) {
    //   this.machineSelected = JSON.parse(
    //     sessionStorage.getItem("selectedMachine")
    //   ).machine_name;
    //   this.machineTriggered(
    //     JSON.parse(sessionStorage.getItem("selectedMachine")).id
    //   );
    // }
    this.machineSelected = null;
  },

  watch: {
    "$vuetify.breakpoint.width"() {
      // Check the width and update durationSelected accordingly
      this.updateDurationSelected();
    },
  },

  computed: {
    // inside computed
    isCardVisible() {
      return this.show_card;
    },
  },

  methods: {
    handleUserSelected(userData) {
      this.userSelected = userData;
      console.log("kkkkkkkkkkkkkkkkkk", this.userSelected.userId);
      if (this.userSelected) {
        this.updateAndSubmit();
      }
    },
    updateDurationSelected() {
      if (this.$vuetify.breakpoint.width <= 600) {
        this.durationSelected = `${new Date(
          this.startTime * 1000
        ).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })} <br> ${new Date(this.endTime * 1000).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      } else {
        this.durationSelected = `${new Date(
          this.startTime * 1000
        ).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })} --> ${new Date(this.endTime * 1000).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      }
    },

    triggermachine(event) {
      // this method is called from inputFiled component to make a API call for new machine's data
      console.log("checking after selecting", event);
      this.machineSelected = event["selectmachine"];
      this.machineItems = event["data"].Items;
      console.log("this.machineItems this.machineItems", this.machineItems);
      for (let i = 0; i < this.machineItems.length; i++) {
        if (this.machineItems[i].id == this.machineSelected) {
          sessionStorage.setItem(
            "selectedMachine",
            JSON.stringify(this.machineItems[i])
          );
        }
      }

      if (this.machineSelected) {
        this.updateAndSubmit();
      }
    },
    incompleteFields() {
      if (this.selectingPredefinedDuration == null) {
        return (
          this.date == null ||
          this.time == null ||
          this.date_2 == null ||
          this.selectedTimeTo == null
        );
      }
      return false;
    },

    // Only setMachineData() and updateAndSubmit() methods helps to call parent and are dependents of other methods defined
    updateAndSubmit() {
      //redirect method
      // console.log("nnnnnnnnnnnnnn", this.userSelected);

      console.log("filterdata", this.filter_data);
      if (this.filter_data !== undefined) {
        console.log("inside updateAndSubmit");
        if (
          this.filter_data.redirectStartDate !== undefined &&
          this.filter_data.redirectStartDate !== null
        ) {
          let redirect_date_time = new Date(
            this.filter_data.redirectStartDate * 1000
          );
          let redirect_date = `${redirect_date_time.getFullYear()}-${redirect_date_time.getMonth()}-${redirect_date_time.getDate()}`;
          let redirect_time = `${redirect_date_time.getHours()}:${redirect_date_time.getMinutes()}`;
          console.log(
            "redirect_date,redirect_time",
            redirect_date,
            redirect_time
          );
          console.log(
            "Actual date and time",
            this.date,
            this.date_2,
            this.time,
            this.selectedTimeTo
          );
        }
      }

      //redirect method
      // checkbox -> status of realtime,
      // date, time -> start time
      // date_2, time_2 -> end time
      // selectingPredefinedDuration -> value selected from 'Last' dropdown in date time input
      // date_func -> value of the aggregation selected in "Data aggregation function"
      // grp_show -> value selected for 'Grouping Interval'

      console.log(
        "updateAndSubmit running",
        this.checkbox,
        this.date,
        this.time,
        this.date_2,
        this.selectedTimeTo,
        this.selectingPredefinedDuration,
        this.date_func,
        this.grp_show,
        this.lengthOfMachine
      );
      this.selectDateMethod();

      //route redirection
      if (this.filter_data !== undefined) {
        if (
          this.filter_data.redirectPath !== undefined &&
          this.$router.app._route.params.route_path !== null
        ) {
          console.log(
            "Inner true condtion",
            this.$router.app._route.name,
            this.filter_data.redirectPath
          );
          if (this.$router.app._route.name === this.filter_data.redirectPath) {
            console.log("most inner condition statisfied");
            this.startTime = this.filter_data.redirectStartDate;
            this.endTime = this.filter_data.redirectEndDate;
          }
        }
      }

      if (window.innerWidth <= 600) {
        // For smaller screens, use <br> for line break
        this.durationSelected = `${new Date(
          this.startTime * 1000
        ).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })} <br> ${new Date(this.endTime * 1000).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      } else {
        // For larger screens, use "-->" for no line break
        this.durationSelected = `${new Date(
          this.startTime * 1000
        ).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })} --> ${new Date(this.endTime * 1000).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      }

      this.$toasted
        .show(
          `${new Date(this.startTime * 1000).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })} -->  ${new Date(this.endTime * 1000).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}`
        )
        .goAway(6000);
      // console.log("this.userSelected.userId", this.userSelected.userId);
      if (this.show_machine && this.enableUserDropDown) {
        console.log("n");
      }
      if (this.$config.user_selectable_routes.includes(this.$route.name)) {
        this.$parent.intervalFetchData(
          this.machineSelected,
          this.startTime,
          this.endTime,
          // this.show,
          this.date_func,
          this.grp_show,
          this.checkbox,
          this.userSelected.userId
        );
      } else {
        this.$parent.intervalFetchData(
          this.machineSelected,
          this.startTime,
          this.endTime,
          // this.show,
          this.date_func,
          this.grp_show,
          this.checkbox
        );
      }

      this.show_card = false;
      this.dialog = false;
      this.dialog_2 = false;

      if (this.selectingPredefinedDuration != "") {
        console.log(
          "Time selector",
          [this.startTime, this.endTime],
          this.selectingPredefinedDuration
        );
      }
    },

    setMachineData(routed_machine) {
      console.log("routed_machine inside set machine data", routed_machine);
      let endPoint = "getMachines";
      if (this.$route.name == "OverallAuditData") {
        endPoint = "getAuditName";
      }

      let config = {
        method: "get",
        url: `${this.$config.backend_url}/${endPoint}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.lengthOfMachine = response.data.data.length;
          let selectedMachined = JSON.parse(
            sessionStorage.getItem("selectedMachine")
          );
          // Check if selectedMachine exists sessionStorage Obj
          if (selectedMachined) {
            const hasMatchingDrilldown = response.data.data.some((machine) =>
              machine.drilldown_id.includes(selectedMachined.drilldown_id)
            );
            // Remove selectedMachine from sessionStorage if no matching drilldown_id is found
            if (!hasMatchingDrilldown) {
              sessionStorage.removeItem("selectedMachine");
            }
          }
          // the following block checks if more than one machine -> if yes than will assign it by default to the instance //
          if (this.lengthOfMachine > 1 && this.machineSelected != null) {
            this.machineSelected = null;
          } else if (this.lengthOfMachine == 1 && routed_machine == null) {
            this.machineSelected = response.data.data[0].id;
          }
          //----------------end--------------------------- //

          //
          if (routed_machine != null) {
            this.machineSelected = routed_machine;
          }
          let machineData = response.data.data || [];

          this.machineItems = machineData;

          if (this.$route.name == "boxplot") {
            this.machineItems.push({ id: "all", machine_name: "All Machines" });
          }

          this.selectDateMethod();

          if (this.filter_data !== undefined) {
            if (
              this.filter_data.redirectStartDate !== undefined &&
              this.filter_data.redirectStartDate !== null
            ) {
              //start redirect time
              let redirect_start_date_time = new Date(
                this.filter_data.redirectStartDate * 1000
              );
              let redirect_start_date = `${this.paddingMethod(
                redirect_start_date_time.getFullYear()
              )}-${this.paddingMethod(
                redirect_start_date_time.getMonth() + 1
              )}-${this.paddingMethod(redirect_start_date_time.getDate())}`;
              let redirect_start_time = `${this.paddingMethod(
                redirect_start_date_time.getHours()
              )}:${this.paddingMethod(redirect_start_date_time.getMinutes())}`;

              this.time = redirect_start_time;
              this.date = redirect_start_date;

              //end redirect time
              let redirect_end_date_time = new Date(
                this.filter_data.redirectEndDate * 1000
              );
              let redirect_end_date = `${this.paddingMethod(
                redirect_end_date_time.getFullYear()
              )}-${this.paddingMethod(
                redirect_end_date_time.getMonth() + 1
              )}-${this.paddingMethod(redirect_end_date_time.getDate())}`;
              let redirect_end_time = `${this.paddingMethod(
                redirect_end_date_time.getHours()
              )}:${this.paddingMethod(redirect_end_date_time.getMinutes())}`;
              this.selectedTimeTo = redirect_end_time;
              this.date_2 = redirect_end_date;
            }
          }

          if (this.filter_data !== undefined) {
            if (this.filter_data.redirectPath !== undefined) {
              console.log(
                "Inner true condtion",
                this.$router.app._route.name,
                this.filter_data.redirectPath
              );
              if (
                this.$router.app._route.name === this.filter_data.redirectPath
              ) {
                console.log("most inner condition statisfied");
                this.startTime = this.filter_data.redirectStartDate;
                this.endTime = this.filter_data.redirectEndDate;
              }
            }
          }

          if (window.innerWidth <= 600) {
            // For smaller screens,  <br> for line break
            this.durationSelected = `${new Date(
              this.startTime * 1000
            ).toLocaleString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })} <br> ${new Date(this.endTime * 1000).toLocaleString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}`;
          } else {
            // For larger screens, "-->" for no line break
            this.durationSelected = `${new Date(
              this.startTime * 1000
            ).toLocaleString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })} --> ${new Date(this.endTime * 1000).toLocaleString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}`;
          }

          this.$toasted
            .show(
              `${new Date(this.startTime * 1000).toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })} --> ${new Date(this.endTime * 1000).toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })}`
            )
            .goAway(6000);
          // }

          this.$parent.intervalFetchData(
            this.machineSelected,
            this.startTime,
            this.endTime,
            this.date_func,
            this.grp_show,
            this.checkbox
          );

          // this.$router.app._route.params.start_date = null;
          // this.$router.app._route.params.end_date = null;
          // this.$router.app._route.params.route_path = null;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            console.log("error--getMachineNames", error);
          }
        });
    },
    DialogPopUp() {
      this.show_card = !this.show_card;

      if (!this.show_card) {
        this.HideFromCalender = false;
        this.HideToCalender = false;
        this.HideTimeToMenu = false;
        this.menu4 = false;
      }
      console.log(
        "This is the methodthis.Last to activate dialog of real time",
        this.show_card,
        this.dialog_2,
        this.selectingPredefinedDuration,
        this.date,
        typeof this.selectingPredefinedDuration,
        typeof this.date
      );
      if (this.date != null) {
        this.Last = false;
        this.timeperiod = true;
        this.time_period = true;
      } else if (this.date == null) {
        this.Last = true;
        this.timeperiod = false;
        this.time_period = null;
      }

      console.log("after activating", this.show_card, this.date_func);
      this.grp_show = null;

      this.show = false;
      this.date_func = null;
    },
    onCancel() {
      console.log("before cance", this.show_card);
      this.time_period = false;
      this.show_card = false;
      this.dialog = false;
      this.dialog_2 = false;
      this.show = false;
      this.hideLastSelectField = true;
      this.hideDateTimeFrom = null;
      this.date = null;
      this.hideToDateTime = false;
      this.time = "00:00";
      this.date_2 = null;
      this.selectedTimeTo = "23:59";
      console.log("after cancel", this.show_card);
    },

    AssignAggregation(a) {
      this.date_func = a;
      console.log("data function", a);
      if (this.date_func == "none") {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    AssignInterval(b) {
      this.grp_show = b;
      console.log("grouping interval", b);
    },
    RadioInput() {
      console.log("inside method_1 call for 'last' time select");

      this.hideLastSelectField = !this.hideLastSelectField;

      this.hideDateTimeFrom = false;
      this.hideToDateTime = false;
      this.show_7 = false;
      console.log("end of method 1");
    },

    TimePeriodRadioSelect() {
      console.log(
        "inside TimePeriodRadioSelect call for 'time period' time select"
      );
      console.log("hideDateTimeFrom", this.hideDateTimeFrom);
      this.hideDateTimeFrom = !this.hideDateTimeFrom;
      this.hideToDateTime = !this.hideToDateTime;
      this.hideLastSelectField = false;
      this.selectingPredefinedDuration = null;
    },
    OnLastSelected() {
      console.log(
        "checking what all activates in method5",
        this.select_last,
        this.date,
        this.selectingPredefinedDuration
      );

      this.date = null;
      this.time = "00:00";
      this.date_2 = null;
      this.selectedTimeTo = "23:59";

      this.selectDateMethod();

      // }
    },
    paddingMethod(InputNumber) {
      //to add padding to number if digit less than 2
      return String(InputNumber).padStart(2, "0");
    },

    // The following method helps to create unix from input date and time from user or by default
    selectDateMethod() {
      console.log(
        "start and end time",
        this.startTime,
        this.endTime,
        this.checkbox
      );
      console.log(
        "this.selectingPredefinedDuration",
        this.selectingPredefinedDuration
      );
      let currentDateTimeSecs = Math.round(Date.now() / 1000);
      if (this.selectingPredefinedDuration != null) {
        this.startTime =
          currentDateTimeSecs - 3600 * this.selectingPredefinedDuration;
        this.endTime = currentDateTimeSecs;
      } else {
        console.log("this.time ", this.time, this.date);

        let fromTime = this.time.split(":");
        let secondsFromTime = fromTime[0] * 3600 + fromTime[1] * 60;
        let fromDate = this.date.split("-");
        let newStartDate = new Date(fromDate[0], fromDate[1] - 1, fromDate[2]);
        this.startTime = newStartDate.getTime() / 1000 + secondsFromTime;

        let toTime = this.selectedTimeTo.split(":");
        let secondsToTime = toTime[0] * 3600 + toTime[1] * 60;
        let toDate = this.date_2.split("-");
        let newEndDate = new Date(toDate[0], toDate[1] - 1, toDate[2]);
        this.endTime = newEndDate.getTime() / 1000 + secondsToTime;
        console.log(
          "checking interval in else ",
          this.startTime,
          this.endTime,
          this.checkbox
        );
      }
    },

    machineTriggered(event) {
      console.log("trigger machine event is ", event);
      this.machineSelected = event;
      for (let i = 0; i < this.machineItems.length; i++) {
        if (this.machineItems[i].id == this.machineSelected) {
          sessionStorage.setItem(
            "selectedMachine",
            JSON.stringify(this.machineItems[i])
          );
        }
      }

      if (this.machineSelected) {
        this.updateAndSubmit();
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-card1 {
  position: absolute;
  z-index: 999;
  width: 100%;
}

#button1 {
  position: relative;
}

.card-btns {
  display: flex;
  justify-content: space-evenly;
  padding: 5% 20px;
}

.update .cancel {
  padding-right: 10px;
  padding-left: 10px;
}
.dialog {
  margin-top: 190px;
  margin-left: 380px;
  height: 430px;
  position: auto;
}

.radio {
  margin-top: 15px;
}
</style>
